jQuery(function($){
  // Show the navbar when the page is scrolled up
  var MQL = 319;

  //primary navigation slide-in effect
  if ($(window).width() > MQL) {
    var headerHeight = $('.site-header-sticky').height();
    $(window).on('scroll', {
      previousTop: 0
    },
                 function() {
      var currentTop = $(window).scrollTop();
      //check if user is scrolling up
      if (currentTop < this.previousTop) {
        //if scrolling up...
        if (currentTop > 0 && $('.site-header-sticky').hasClass('is-fixed')) {
          $('.site-header-sticky').addClass('is-visible');
        } else {
          $('.site-header-sticky').removeClass('is-visible is-fixed');
        }
      } else if (currentTop > this.previousTop) {
        //if scrolling down...
        $('.site-header-sticky').removeClass('is-visible');
        if (currentTop > headerHeight && !$('.site-header-sticky').hasClass('is-fixed')) $('.site-header-sticky').addClass('is-fixed');
      }
      this.previousTop = currentTop;
    });
  }

});
/*------Change quantity input------*/
$(document).on('click', '.qty-minus', function(){
  var currentVal = parseInt($(this).next().val());
  if(currentVal > 1){
    currentVal -= 1;
  } 
  $(this).next().val(currentVal);
});
$(document).on('click', '.qty-plus', function(){
  var currentVal = parseInt($(this).prev().val());
  currentVal += 1;
  $(this).prev().val(currentVal);
});

$(document).ready(function(){

  //Footer mobile menu 
  if ($(window).width() <= 767){
    $('.site-footer__nav-title').toggleClass('inactive');
    $('.site-footer__nav-title').click(function () {
      if($(this).is('.inactive')) {
        $('.active').toggleClass('active').toggleClass('inactive').next().slideToggle().toggleClass('open');
        $(this).toggleClass('active').toggleClass('inactive');
        $(this).next().slideToggle().toggleClass('open');
      }
      else {
        $(this).toggleClass('active').toggleClass('inactive');
        $(this).next().slideToggle().toggleClass('open');
      }
    });
    return false;
  }
});



jQuery(function($){

  // Slick
  $('.custom-reviews__slide').slick({
    arrows: false,
  });

  // Custom carousel nav
  $('.carousel-prev').click(function(){ 
    $(this).parent().find('.custom-reviews__slide').slick('slickPrev');
  } );

  $('.carousel-next').click(function(e){
    e.preventDefault(); 
    $(this).parent().find('.custom-reviews__slide').slick('slickNext');
  });

  $('#notice-bar-id').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false
  })

});

$('.custom_field_products.carousel-enable').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  speed: 100,
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.logo-list').slick({
  infinite: true,
  autoplay: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  speed: 500,
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

jQuery(function($){

  $('.journal-slider').slick({
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.journal-nav'
  });

  // Custom carousel nav
  $('.carousel-prev').click(function(){ 
    $(this).parent().find('.journal-slider').slick('slickPrev');
  });

  $('.carousel-next').click(function(e){
    e.preventDefault(); 
    $(this).parent().find('.journal-slider').slick('slickNext');
  });  

  $('.journal-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.journal-slider',
    arrows: false,
    dots: false,
    focusOnSelect: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

});

jQuery(function($){

  $('.featured--collection').slick({
    centerMode: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // Custom carousel nav
  $('.featured-collection__prev').click(function(){ 
    $(this).parent().find('.featured--collection').slick('slickPrev');
  });

  $('.featured-collection__next').click(function(e){
    e.preventDefault(); 
    $(this).parent().find('.featured--collection').slick('slickNext');
  });  

});


jQuery(function($){
  $(document).on('click','.ingredients-images .img_text_tab',function(){

    var targetTo = $(this).attr('triggerto');
    $(this).parent().siblings().removeClass('active');
    $(this).parent().addClass('active');
    $('.'+targetTo).siblings().removeClass('active');
    $('.'+targetTo).addClass('active');

  });

});

jQuery(function($){
  $(document).on('click','.desc-tab a',function(){

    var targetTo = $(this).attr('triggerto');
    $(this).parent().siblings().removeClass('active');
    $(this).parent().addClass('active');
    $('.'+targetTo).siblings().removeClass('active');
    $('.'+targetTo).addClass('active');

  });  

});



// recentview slider

// theme.RecentlyViewed = (function () {
//    console.log("recentlyViewed-item:- "+recentlyViewed.length);
// });

jQuery(function($){
  //     setTimeout(function(){
  //   //     var $st = $('.pagination');
  //   var $slickEl = $('.recently-viewed-products__list');

  //   $slickEl.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //     var i = (currentSlide ? currentSlide : 0) + 1;
  //     //   $st.text(i + ' of ' + slick.slideCount);
  //   });

  //   $slickEl.slick({
  //     centerMode: true,
  //     centerPadding: '200px',
  //     slidesToShow: 2,
  //     focusOnSelect: false,
  //     dots: false,
  //     infinite: true,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           arrows: false,
  //           centerMode: true,
  //           centerPadding: '40px',
  //           slidesToShow: 2
  //         }
  //       },
  //       {
  //         breakpoint: 480,
  //         settings: {
  //           arrows: false,
  //           centerMode: true,
  //           centerPadding: '40px',
  //           slidesToShow: 2
  //         }
  //       }
  //     ]
  //   }); }, 4000);
});


// home page blog catagory section
jQuery(function($){

  var options = {
    autoplay: true,
    autoplaySpeed: 7000,
    arrow: true,
    slidesToShow: 3,
    adaptiveHeight: true,
        dots: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  }

  document.wellecoSlickOptions = options;


  var sliderID = '#Slideshow-'+$('.blogTag-linkto.active').attr('id');
  var $slider = $(sliderID);
  var $progressBar = $('.tag_progress_'+$('.blogTag-linkto.active').attr('id')+'');
  var $progressBarLabel = $( '.tag_progress_'+$('.blogTag-linkto.active').attr('id')+' .slider__label' );

  console.log(sliderID);
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    $progressBar
    .css('background-size', calc + '% 100%')
    .attr('aria-valuenow', calc );
//     $progressBarLabel.text( calc + '% completed' );
  });
  
  
//   $slider.slick(options);
  
  
  $(document).on('click', '.blogTag-linkto', function(){
    var linkto = $(this).attr('linkto');
    var blockId = '#Slideshow-'+$(this).attr('id');
     var $progressBarr = $('.tag_progress_'+$(this).attr('id')+'');
  var $progressBarLabell = $( '.tag_progress_'+$(this).attr('id')+' .slider__label' );

    console.log(blockId);
    $(this).siblings('.blogTag-linkto').removeClass('active');
    $(this).addClass('active');
    
    $('[link_from="'+linkto+'"]').siblings('.latest-blog-posts').addClass('hide');
    $('[link_from="'+linkto+'"]').removeClass('hide');
    
    $(blockId).slick('unslick');
    $(blockId).slick(options);
    $(blockId).on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
      $progressBarr
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
      //     $progressBarLabel.text( calc + '% completed' );
    });
    //         $('[link_from="'+linkto+'"]').siblings('.latest-blog-posts').hide();
    //     $('[link_from="'+linkto+'"]').show();
  });
});

jQuery(function($){
  
  $('.login-popout .login-form__forgot-btn').click(function() {
    $('.login-popout').addClass('forget-pwd');
    return false;
  });

  $('.login-form__forgot-btn').click(function() {
    $('.login-form-password').addClass('show');
    $(this).parents('.login-form-wrapper').addClass('hidden');
    return false;
  });

  $('.recover-password__btn').click(function() {
    $('.login-form-wrapper').removeClass('hidden');
    $(this).parents('.login-form-password').removeClass('show');
    return false;
  });
  
  $('.open-signup-form').click(function() {
    $('.login-popout').addClass('open-signup');
    return false;
  });
  
  $('.return-login').click(function() {
    $('.login-popout').removeClass('open-signup');
    return false;
  });  

});

$(document).ready(function(){
  let elements = document.getElementsByClassName("site-nav__link");
  for(let i = 0; i < elements.length; i++) {
      elements[i].onclick = function () {
        elements[i].classList.toggle("active");
      }
  }
});

jQuery(function($){
  
  $('.ingredient-accordion-holder .accordion-title').click(function() {
    $(this).parent().toggleClass('active');
    return false;
  });  

});
